import React, { FC } from 'react';
import AggregatedCsvReport from './AggregatedCsvReport';
import BackgroundCsvReport from './BackgroundCsvReport';

const BillingCsvReport: FC = () => {
  return (
    <>
      <BackgroundCsvReport />
      <AggregatedCsvReport />
    </>
  );
};

export default BillingCsvReport;
